import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Feedback } from '../_models/index';
import { environment } from '../../environments/environment';

var URL = environment.url_django;

@Injectable()
export class FeedbackService {

    constructor(private http: HttpClient) { }

    create(feedback: Feedback) {
        console.log(feedback)
        return this.http.post(URL+'pss_app/feedback', feedback);
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/feedback.service.ts